import { useLocalization } from "@i18n";

import type { GeneralStructureType } from "../api/generalDashboard/generalDashboard.types";

type GeneralStructureComingSoonPageProps = {
  structureType?: GeneralStructureType;
};

const GeneralStructureComingSoonPage = ({
  structureType,
}: GeneralStructureComingSoonPageProps) => {
  const { translate } = useLocalization();

  return (
    <section
      className="flex flex-col gap-2 p-6"
      {...(structureType ? { "data-structure-type": structureType } : {})}
    >
      <h1 className="text-2xl font-semibold">
        {translate("general.comingSoon.title")}
      </h1>
      <p className="text-sm text-muted-foreground">
        {translate("general.comingSoon.description")}
      </p>
    </section>
  );
};

export default GeneralStructureComingSoonPage;
